import { Component, OnInit, Input, OnChanges, SimpleChanges, inject, DestroyRef, EventEmitter, Output } from '@angular/core';
import * as ExcelJS from "exceljs/dist/exceljs.min.js";
import * as FileSaver from 'file-saver';
import * as moment_timezone from 'moment-timezone'
import { TableDataConstants } from 'src/app/models/tableData_constants';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import englishLang from '../../../../../assets/i18n/IN.json';
import frenchLang from '../../../../../assets/i18n/FR.json'
import { StorageService } from 'src/app/services/storage.service';
import { DateTimeService } from 'src/app/services/date-time/date-time.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { startWith } from 'rxjs';
import * as moment from 'moment';
import { Router } from '@angular/router';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const momentTz = moment_timezone;
const dateFormat = "YYYYMMDDhhmmssS";
// Required output shape: YYYYMMDDHHMMSSS (Moment tokens must use mm/ss for minute/second).
const frDateFormat = "YYYYMMDDHHmmssS";

@Component({
  selector: 'download-table',
  standalone: false,
  templateUrl: './download-table.component.html',
  styleUrls: ['./download-table.component.scss'],
  providers: [DatePipe, TitleCasePipe]
})
export class DownloadTableComponent implements OnInit, OnChanges {
  private destroyRef = inject(DestroyRef);

  @Input() splitDownloadOptions: MenuItem[];
  @Input() btnName: string = "Download";
  @Input() type: String = "button";
  @Input() tableType: any;
  @Input() selectedRows: any;
  @Input() selectedCriteria: any;
  @Input() tableData: any;
  @Input() userList: any;
  @Input() manualTypeInvoice: boolean;
  @Input() disabled: boolean = false;
  @Output() onDownloadCheckBoxSelected = new EventEmitter<any>();
  @Output() onDownloadTableData = new EventEmitter<any>();
  @Output() clearSelectedRows = new EventEmitter<any>();

  valid: boolean = false;
  splitDownloadItems: MenuItem[];
  lang: string;
  public selectedCountry: string;
  dateFormat24Hrs = 'YYYYMMDDHHmmssS';
  downloadLabelText: string;

  constructor(
    private titlecasePipe: TitleCasePipe,
    private storageService: StorageService,
    private dateTimeService: DateTimeService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private router: Router) {

  }

  ngOnInit() {
    this.selectedCountry = this.storageService.getWithDefaultPassphrase("Country");

    this.translate.onLangChange
      .pipe(
        startWith({ lang: this.translate.currentLang || this.translate.getDefaultLang() } as LangChangeEvent),
        takeUntilDestroyed(this.destroyRef))
      .subscribe((event: LangChangeEvent) => {
        this.lang = event.lang;
        this.getSplitDownloadItems();
        this.updateDownloadLabelText();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['splitDownloadOptions'] || changes['tableType']) {
      this.getSplitDownloadItems();
    }

    if (changes['manualTypeInvoice']) {
      this.updateDownloadLabelText();
    }
  }

  downloadExcelTableData(selectedRows?) {
    this.selectedRows = selectedRows ? selectedRows : this.selectedRows;
    if(this.selectedCountry == 'MY' && this.selectedRows?.length > 0) {
      // this.onDownloadCheckBoxSelected.emit({selected:false,criteria:this.selectedCriteria});
      const tableType = this.tableType.includes('DT_AUTO') ? 'DT_AUTO' : this.tableType;
      let tableDetails = TableDataConstants.TableDataMap[tableType];
      let workbook = new ExcelJS.Workbook();
      let worksheet: any;
  
      worksheet = workbook.addWorksheet('TableData', { properties: { tabColor: { argb: 'FFC0000' } } });
      if (tableType === 'DT_AUTO') {
        const headersMap = {
          'PL': ['Inprogress_KSeF||L1:L1', 'Success_KSeF||M1:M1', 'Error_KSeF||N1:N1'],
          'MY': ['Inprogress_IRBM||L1:L1', 'Success_IRBM||M1:M1', 'Error_IRBM||N1:N1'],
          'RO': ['Inprogress_Mof||L1:L1', 'Success_MoF||M1:M1', 'Errors_MoF||N1:N1'],
          'AU': ['Inprogress_Peppol||L1:L1', 'Success_Peppol||M1:M1', 'Errors_Peppol||N1:N1'],
        };
        if (headersMap[this.selectedCountry]) {
          headersMap[this.selectedCountry].forEach((header, index) => {
            tableDetails['headers'][0][11 + index] = header;
          });
        }
      }
  
      if (tableDetails['headers'].length > 0) {
        let rows = tableDetails['headers'].length;
        for (let row = 1; row <= rows; row++) {
          let columns = tableDetails['headers'][row - 1];
          for (let col = 0; col < columns.length; col++) {
            let columnValues = columns[col].split("||");
            let initCell = columnValues[1].split(":");
            worksheet.mergeCells(columnValues[1]);
            worksheet.getCell(initCell[0]).value = columnValues[0];
            worksheet.getCell(initCell[0]).font = { bold: true, }
            worksheet.getCell(initCell[0]).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell(initCell[0]).alignment = { vertical: 'center', horizontal: 'center', wrapText: true };
          } 
        }
      }
  
      worksheet.columns = tableDetails['columns'];
      worksheet.columns = tableDetails['columns'].map(column => {
        if (column.key === 'attachmentExistExcel') {
          return {
            ...column,
            style: { alignment: { wrapText: true } }
          };
        }
        return column;
      });
      if (this.selectedRows !== null && this.selectedRows !== undefined) {
        // let formattedData = this.formatValues(this.tableData, tableDetails['formats'])
        let formatsMap = new Map(Object.entries(tableDetails['formats']));
        let formattedData = this.formatValues(this.selectedRows, formatsMap);
        formattedData.forEach(function (value) {
        if (value.respDt && !value.respDt.endsWith(":00")) {
                    value.respDt += ":00";
        }
          worksheet.addRow(value);
        });
      }
  
  
      tableDetails['cells'].map(key => {
        worksheet.getCell(key).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'c4c4cd' }
        };
      });
  
      workbook.xlsx.writeBuffer().then(data => {
  
        const blob = new Blob([data], { type: EXCEL_TYPE });
  
        const userTime = this.selectedCountry === 'MY'
          ? this.dateTimeService.getUserCurrentDateTime() + "_" + this.dateTimeService.getTimeZone()
          : this.selectedCountry === 'FR'
            ? momentTz.tz('Europe/Paris').format(frDateFormat)
            : momentTz.tz(this.getZone()).format(dateFormat);
        
        let finalName = tableDetails['fileBaseName'].concat(userTime);
        FileSaver.saveAs(blob, finalName + EXCEL_EXTENSION);
      });
      this.clearSelectedRows.emit(true);
    } else if (['RO', 'IT', 'PL', 'FR'].includes(this.selectedCountry)) {
      // For RO, IT, PL, FR countries, we handle the download differently based on selected rows
      if (this.selectedRows?.length > 0) {
        this.downloadSyncData();
        this.clearSelectedRows?.emit(true);
      } else if (['IT']?.includes(this.selectedCountry) &&  ['reports']?.includes(this.router.url.split('/')[this.router.url.split('/').length - 1])) {
        this.downloadData();
      } else {
        this.onDownloadTableData.emit();
      }
    } else{
      if(['receipts', 'invoice-management', 'inward-invoices-my'].includes(this.router.url.split('/')[this.router.url.split('/').length - 1])) {
        this.onDownloadCheckBoxSelected.emit({selected:true,criteria:this.selectedCriteria});
      }else {
        this.downloadData();
      } 
    }
  }
  downloadSyncData() {
    const tableType = this.tableType.includes('DT_AUTO') ? 'DT_AUTO' : this.tableType;
          let tableDetails = TableDataConstants.TableDataMap[tableType];
          let workbook = new ExcelJS.Workbook();
          let worksheet: any;
  
          worksheet = workbook.addWorksheet('TableData', { properties: { tabColor: { argb: 'FFC0000' } } });
          if (tableType === 'DT_AUTO') {
            const headersMap = {
              'PL': ['Inprogress_KSeF||L1:L1', 'Success_KSeF||M1:M1', 'Error_KSeF||N1:N1'],
              'MY': ['Inprogress_IRBM||L1:L1', 'Success_IRBM||M1:M1', 'Error_IRBM||N1:N1'],
              'RO': ['Inprogress_Mof||L1:L1', 'Success_MoF||M1:M1', 'Errors_MoF||N1:N1'],
              'AU': ['Inprogress_Peppol||L1:L1', 'Success_Peppol||M1:M1', 'Errors_Peppol||N1:N1'],
              'FR': ['Inprogress_PA||L1:L1', 'Success_PA||M1:M1', 'Error_PA||N1:N1']
            };
            if (headersMap[this.selectedCountry]) {
              headersMap[this.selectedCountry].forEach((header, index) => {
                tableDetails['headers'][0][11 + index] = header;
              });
            }
          }
  
          if (tableDetails['headers'].length > 0) {
            let rows = tableDetails['headers'].length;
            for (let row = 1; row <= rows; row++) {
              let columns = tableDetails['headers'][row - 1];
              for (let col = 0; col < columns.length; col++) {
                let columnValues = columns[col].split("||");
                let initCell = columnValues[1].split(":");
                worksheet.mergeCells(columnValues[1]);
                worksheet.getCell(initCell[0]).value = columnValues[0];
                worksheet.getCell(initCell[0]).font = { bold: true, }
                worksheet.getCell(initCell[0]).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                worksheet.getCell(initCell[0]).alignment = { vertical: 'center', horizontal: 'center', wrapText: true };
              }
            }
          }
  
          worksheet.columns = tableDetails['columns'];
          worksheet.columns = tableDetails['columns'].map(column => {
            if (column.key === 'attachmentExistExcel') {
              return {
                ...column,
                style: { alignment: { wrapText: true } }
              };
            }
            return column;
          });
          if (this.selectedRows !== null && this.selectedRows !== undefined) {
            // let formattedData = this.formatValues(this.tableData, tableDetails['formats'])
            let formatsMap = new Map(Object.entries(tableDetails['formats']));
            let formattedData = this.formatValues(this.selectedRows, formatsMap);
            formattedData.forEach(function (value) {
             if (value.respDt && !value.respDt.endsWith(":00")) {
                      value.respDt += ":00";
                  }
              worksheet.addRow(value);
            });
          }
  
  
          tableDetails['cells'].map(key => {
            worksheet.getCell(key).fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'c4c4cd' }
            };
          });
  
          workbook.xlsx.writeBuffer().then(data => {
  
            const blob = new Blob([data], { type: EXCEL_TYPE });
  
            const userTime = this.selectedCountry === 'MY'
              ? this.dateTimeService.getUserCurrentDateTime() + "_" + this.dateTimeService.getTimeZone()
              : this.selectedCountry === 'FR'
                ? momentTz.tz('Europe/Paris').format(frDateFormat)
                : momentTz.tz(this.getZone()).format(dateFormat);
            let finalName = tableDetails['fileBaseName'].concat(userTime);
            FileSaver.saveAs(blob, finalName + EXCEL_EXTENSION);
          });
          this.clearSelectedRows.emit(true)

      }
  downloadData(){
    const tableType = this.tableType.includes('DT_AUTO') ? 'DT_AUTO' : this.tableType;
      let tableDetails = TableDataConstants.TableDataMap[tableType];
      let workbook = new ExcelJS.Workbook();
      let worksheet: any;
  
      worksheet = workbook.addWorksheet('TableData', { properties: { tabColor: { argb: 'FFC0000' } } });
      if (tableType === 'DT_AUTO') {
        const headersMap = {
          'PL': ['Inprogress_KSeF||L1:L1', 'Success_KSeF||M1:M1', 'Error_KSeF||N1:N1'],
          'MY': ['Inprogress_IRBM||L1:L1', 'Success_IRBM||M1:M1', 'Error_IRBM||N1:N1'],
          'RO': ['Inprogress_Mof||L1:L1', 'Success_MoF||M1:M1', 'Errors_MoF||N1:N1'],
          'AU': ['Inprogress_Peppol||L1:L1', 'Success_Peppol||M1:M1', 'Errors_Peppol||N1:N1'],
          'FR': ['Inprogress_PA||L1:L1', 'Success_PA||M1:M1', 'Error_PA||N1:N1']
        };
        if (headersMap[this.selectedCountry]) {
          headersMap[this.selectedCountry].forEach((header, index) => {
            tableDetails['headers'][0][11 + index] = header;
          });
        }
      }
  
      if (tableDetails['headers'].length > 0) {
        let rows = tableDetails['headers'].length;
        for (let row = 1; row <= rows; row++) {
          let columns = tableDetails['headers'][row - 1];
          for (let col = 0; col < columns.length; col++) {
            let columnValues = columns[col].split("||");
            let initCell = columnValues[1].split(":");
            worksheet.mergeCells(columnValues[1]);
            worksheet.getCell(initCell[0]).value = columnValues[0];
            worksheet.getCell(initCell[0]).font = { bold: true, }
            worksheet.getCell(initCell[0]).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getCell(initCell[0]).alignment = { vertical: 'center', horizontal: 'center', wrapText: true };
          } 
        }
      }
  
      worksheet.columns = tableDetails['columns'];
      worksheet.columns = tableDetails['columns'].map(column => {
        if (column.key === 'attachmentExistExcel') {
          return {
            ...column,
            style: { alignment: { wrapText: true } }
          };
        }
        return column;
      });
      if (this.tableData !== null && this.tableData !== undefined) {
        // let formattedData = this.formatValues(this.tableData, tableDetails['formats'])
        let formatsMap = new Map(Object.entries(tableDetails['formats']));
        let formattedData = this.formatValues(this.tableData, formatsMap);
        formattedData.forEach(function (value) {
          worksheet.addRow(value);
        });
      }
  
  
      tableDetails['cells'].map(key => {
        worksheet.getCell(key).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'c4c4cd' }
        };
      });
  
      workbook.xlsx.writeBuffer().then(data => {
  
        const blob = new Blob([data], { type: EXCEL_TYPE });
  
        const userTime = this.selectedCountry === 'MY'
          ? this.dateTimeService.getUserCurrentDateTime() + "_" + this.dateTimeService.getTimeZone()
          : this.selectedCountry === 'FR'
            ? momentTz.tz('Europe/Paris').format(frDateFormat)
            : momentTz.tz(this.getZone()).format(dateFormat);
        let finalName = tableDetails['fileBaseName'].concat(userTime);
        FileSaver.saveAs(blob, finalName + EXCEL_EXTENSION);
      });
      this.clearSelectedRows.emit(true)
  }

  getZone() {
    switch (this.selectedCountry) {
      case "RO":
        return "EET";
      default:
        return "CET";
    }
  }

  formatValues(tableValues: any[], columns: Map<any, any>): any {
    let formattedValues: any[] = [];
    tableValues.forEach(tableValue => {
      let formatted = {};
      columns.forEach((value: boolean, key: string) => {
        let objKey = value['key'];
        let subkey = value['subkey'];
        let isFormat = value['isformat'];
        let pipeFormat = value['isPipeFormat'];
        let userNameDisplay = value['userNameDisplay'];

        if (isFormat) {
          let formats = value['formats'];
          if (subkey !== null && subkey !== undefined)
            formatted[objKey] = formats[tableValue[objKey][subkey]] !== null
              && formats[tableValue[objKey][subkey]] !== undefined ? formats[tableValue[objKey][subkey]].name : value['default']
          else if (formats[tableValue[objKey]] !== null && formats[tableValue[objKey]] !== undefined) {
            formatted[objKey] = formats[tableValue[objKey]].name;
          } else {
            // Check if value is already a display name (data already transformed by UI)
            const displayNames = Object.values(formats).map((f: any) => f.name);
            if (tableValue[objKey] && displayNames.includes(tableValue[objKey])) {
              formatted[objKey] = tableValue[objKey];
            } else {
              formatted[objKey] = value['default'];
            }
          }
        }
    // let utcDateString = tableValue[objKey];
            // if (utcDateString !== null && utcDateString !== undefined) {
            //   // Convert to a Date object
            //   let utcDate = new Date(utcDateString + 'Z'); // 'Z' indicates the date is in UTC
            //   // Format the Date object to local time using DatePipe
            //   if (!isNaN(utcDate.getTime())) { // Check if the date is valid
            //     // Format the Date object to local time using DatePipe
            //     let formattedDate = this.datePipe.transform(utcDate, dateFormat);
            //     formatted[objKey] = formattedDate;
            //   }
            // } else {
            //   // Handle null or undefined date
            //   formatted[objKey] = value['default'] || ''; // Use the default value or empty string
            // }
        else if (pipeFormat) {
          let pipeType = value['pipeType'];
          let dateFormat = value['pipeformat'];
          let timezone = value['timezone'];
          if (pipeType === 'case') {
            formatted[objKey] = this.titlecasePipe.transform(tableValue[objKey]);
          } else if (pipeType === 'date') {
             if (objKey != null && objKey.trim() !== '') {
              formatted[objKey] = this.datePipe.transform(tableValue[objKey], dateFormat, timezone);
            } else {
              formatted[objKey] = value['default']|| '';
            }
           
          } else {
            formatted[objKey] = tableValue[objKey];
          }
        }
         else if (userNameDisplay) {
          formatted[objKey] = this.userList[tableValue[objKey]]
            ? this.userList[tableValue[objKey]] : tableValue[objKey];
        }
        else if (tableValue[objKey] !== undefined && tableValue[objKey] !== null) {
          if (objKey == "Type") {
            if (["EINV", "B2C", "LIFECYCLE", "ERPT"].includes(tableValue[objKey])) {
              formatted[objKey] = value['default'];
            } else if (tableValue[objKey] == value['default'] || tableValue[objKey].startsWith("Rule ")) {
              // Value is already a display name (data already transformed by UI)
              formatted[objKey] = tableValue[objKey];
            } else {
              formatted[objKey] = "Rule " + tableValue[objKey];
            }
          } else {
            formatted[objKey] = tableValue[objKey];
          }
        }
        else {
          formatted[objKey] = value['default'];
        }
      });

      formattedValues.push(formatted);
    });

    return formattedValues
  }

  getSplitDownloadItems(): void {
    this.splitDownloadItems = [];

    if (this.splitDownloadOptions !== null && this.splitDownloadOptions !== undefined
      && this.splitDownloadOptions.length > 0 && this.splitDownloadOptions[0].items.length > 0) {

      // Clone the menu structure so UI refreshes on parent input updates without mutating the input object.
      this.splitDownloadOptions = this.splitDownloadOptions.map(menu => ({
        ...menu,
        items: menu.items?.map(item => ({ ...item })) || []
      }));

      this.splitDownloadOptions[0].items.forEach(ele => {
        if (ele.label.toLowerCase().includes('report') || ele.label == 'Raport' || ele.label == 'XML sent to KSeF' || ele.label == 'XML sent to MoF' || ele.label == 'XML sent to PPF' || ele.label == 'UPO' || ele.label === 'PDF' || ele.label === 'English PDF' || ele.label === "XML received from MoF"
          || ele.label === "XML received from PPF" || ele.label === "Fichier UBL partagé avec le PPF"
          || ele.label === "Lisible PDF" || ele.label === "Rapport" || ele.label === 'XML Created by GTES'
          || ele.label === "Lisible PDF" || ele.label === "Fichier XML reçu du PPF"
          || ele.label === "Drukuj PDF" || ele.label === "XML" || ele.label === "GTES XML" || ele.label === "GTES Summary XML"
          || ele.label === "SDI XML" || ele.label === "GTES to SDI XML" || ele.label === "SDI Response XML" || ele.label === "Attachment" || ele.label === "XML/JSON received from IRBM"
          || ele.label === "Custom PDF" || ele.label === "Custom XML" || ele.label === "Custom Text" || ele.label === "MoF XML" || ele.label === "Legal Format") {
          } else if (ele.label.toLowerCase() === "table data" 
          && (['INVOICE_MY', 'INVOICE_IT', 'INWARD_INVOICE_FR', 'EREPORTING_FR'].includes(this.tableType)) ) {
                } else {
          ele['command'] = () => { this.downloadExcelTableData() };
        }
      });

      this.splitDownloadItems = this.splitDownloadOptions;

      const translationKeys = [
        'text.rprt',
        'text.tableData',
        'text.xmlSenttoPPF',
        'text.pdfDownload',
        'text.reportDownload',
        'text.tableDownload',
        'text.xmlMovetoPPF'
      ];
      this.translate.get(translationKeys).subscribe(res => {
        this.splitDownloadItems[0].items.forEach(ele => {
          if (this.selectedCountry !== 'FR') {
            if (ele.label == 'Report' || ele.label == 'Raport') {
              ele.label = res['text.rprt'];
            } else if (ele.label == 'Table Data' || ele.label == 'Dane w formie tabeli') {
              ele.label = res['text.tableData'];
            }
          } else {
            if (ele.label == englishLang.text.xmlSenttoPPF || ele.label == frenchLang.text.xmlSenttoPPF) {
              ele.label = res['text.xmlSenttoPPF'];
            } else if (ele.label == englishLang.text.pdfDownload || ele.label == frenchLang.text.pdfDownload) {
              ele.label = res['text.pdfDownload'];
            } else if (ele.label == englishLang.text.reportDownload || ele.label == frenchLang.text.reportDownload) {
              ele.label = res['text.reportDownload'];
            } else if (ele.label == englishLang.text.tableDownload || ele.label == frenchLang.text.tableDownload) {
              ele.label = res['text.tableDownload'];
            } else if (ele.label == englishLang.text.xmlMovetoPPF || ele.label == frenchLang.text.xmlMovetoPPF) {
              ele.label = res['text.xmlMovetoPPF'];
            }
          }
        });
      });
    }
  }

  updateDownloadLabelText(): void {
    this.translate.get(['text.ManualDownload', 'text.downloadIconLabel']).subscribe(res => {
    this.downloadLabelText = this.manualTypeInvoice ?
      res['text.ManualDownload'] :
      res['text.downloadIconLabel'];
    });
  }
}
